/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IUpNextItemType {
  ContinueChallengeWorkout = 'continue-challenge-workout',
  ContinueSeriesWorkout = 'continue-series-workout',
  LiveScheduledWorkout = 'live-scheduled-workout',
  RecommendedWorkout = 'recommended-workout',
  ScheduledWorkout = 'scheduled-workout',
  StaffPickWorkout = 'staff-pick-workout',
}
